export const detectDesignationIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete designation" || cleaned === "remove designation") {
        return { intent: "delete_designation" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) designation/);
    if (deleteMatch) {
        return { intent: "delete_designation", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create designation") || cleaned.includes("add designation")) {
        return { intent: "create_designation" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create designation named (.+)/);
    if (createMatch) {
        return { intent: "create_designation", name: createMatch[1].trim() };
    }

    return null;
};
